import { css } from 'styled-components';
import { colours, fonts } from 'themes/default';
const { fontStyleRegular } = fonts;

// TODO border-radius
export default css`
  ${fontStyleRegular}
  border: 0.05em solid ${colours.Shades.TintBlue20};
  padding: 0.3em;
  border-radius: 0.35em;
  background-color: ${colours.Greyscale.White};
  width: 100%;
  box-sizing: border-box;

  &:disabled {
    background-color: ${colours.Greyscale.SilverGrey};
  }

  &:focus {
    box-shadow: 0 0 0 1px ${colours.Core.CoreNavy};
    outline: none;
  }

  ${({ validationState }) => {
    if (validationState === 'error') {
      return css`
        border-color: ${colours.Messaging.ErrorRed};
        &:focus {
          box-shadow: 0 0 0 3px ${colours.Messaging.ErrorRed};
        }
      `;
    }

    if (validationState === 'warning') {
      return css`
        border-color: ${colours.Core.SecondaryYellow};
        &:focus {
          box-shadow: 0 0 0 3px ${colours.Core.SecondaryYellow};
        }
      `;
    }

    return null;
  }};
`;
